module.exports = __webpack_public_path__ + "img/merchants.18993ea0.png";